import React from 'react'
import { func } from 'prop-types'
import Button from '../ui/button/Button'
import { FIXED_COLORS } from './constants'

const ColorFilters = ({ onClick }) => (
  <div className='color-filters'>
    {FIXED_COLORS.map((item, index) => (
      <Button customClasses={`color-filters--${[item]}`} key={item + index + 'mobile'} onClick={e => onClick(e, item)} />
    ))}
  </div>
)

ColorFilters.propTypes = {
  onClick: func
}

export default ColorFilters